import React, { useState, useEffect } from 'react';
import ReactDOM, {render} from 'react-dom';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';

import RoomIcon from '@material-ui/icons/Room';

//import './App.css';
/*
import {
//  BikeUI,		
//  Budget,
//  TotalUsers,
//  HowToUse,
//  Segment,
//  TotalProfit,
//  LatestSales,
//  UsersByDevice,
//  LatestProducts,
//  LatestOrders
} from './Tab';
*/

import _ from 'lodash';
//import axios from 'axios';
import auth from '../../../utils/auth';

import MapGL, { Marker, Source, Layer, GeolocateControl, NavigationControl, FlyToInterpolator } from 'react-map-gl';
import 'mapbox-gl/dist/mapbox-gl.css';

import decodePolyline from 'decode-google-map-polyline';

import mapboxgl from 'mapbox-gl';
mapboxgl.workerClass = require('worker-loader!mapbox-gl/dist/mapbox-gl-csp-worker').default; // eslint-disable-line

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(1)
  },
  tab: {
    backgroundColor: 'white',
    boxShadow: '0 0 0 1px rgba(63,63,68,0.05), 0 1px 3px 0 rgba(63,63,68,0.15)',
    borderRadius: '4px 4px 0 0' 
  }, 
  tabPanel: {
  	padding: '16px',
    backgroundColor: 'white',
    boxShadow: '0 0 0 1px rgba(63,63,68,0.05), 0 1px 3px 0 rgba(63,63,68,0.15)',
    borderRadius: '0 0 4px 4px'
  },
	title: {
		fontSize:'16px',		 
		color:'#73838b', fontWeight:'500',
    marginBottom: "12px", 
		padding:'0px',
		[theme.breakpoints.up("md")]: {
			fontSize:'20px',
		},
	},
  desc: {
    margin:"0 0 12px 0",
    padding:"12px",
    background:"#f5f5f5"
  }
}));


const Map = () => {
  const classes = useStyles();

  const extraInfo = auth.getExtraInfo() ? auth.getExtraInfo() : {pretest : 'none'};
  const gears = JSON.parse(extraInfo.bikes_json);

//  const [gearinfo, setGearinfo] = React.useState(gears[0]);
//  const [gearTab, setGearTab ] = React.useState(0);

  useEffect(() => {	
	}, []);

  const MAPBOX_TOKEN = process.env.REACT_APP_MAPBOX_TOKEN;

  const [ viewport, setViewport ] = useState({ 
    latitude: 37.591647, longitude: 126.943329,  
    width: '100%',
    height: '500px',
    zoom: 14
  });   
    
  const pData = 'gcndFecneWh@VJ@JADB@BCHD@?Ft@d@p@l@VZVj@d@j@HJNF`@f@f@^FH|AfAF?@GB@jARz@j@rAp@rA|@`AVXLt@l@l@`@RTNXf@Jl@\\b@Jp@j@^Rr@v@d@ZLPHDn@B\\NP@HEVYj@bADBF?LMp@aAfDeEr@s@rCqDFEB?t@bAlCbEBLAN?Db@z@p@fAv@|@f@v@lAvApChEv@zAXr@FFHBNCLc@Ha@hAmBXo@rAgCZw@xAwCDQ@e@FOJITEDEx@gB`@gAz@eB^i@LWNQt@}AXg@@SAKDUFO?IRYTw@BQ?_@ESAa@EMOGAEi@wBKq@@EFB@ANEBDBCF@BIDk@ACE@BE?GW_@?GH_@x@cAd@a@JQV?`Ad@R@NHR@F`@DNDBH?RQD?JFVUHQV[Re@p@qAn@}@HCLFLJHNJGXDVRJRZXp@~@PJHLb@TXb@l@\\\\VT\\h@n@d@`@^d@l@`@r@x@~AtAv@z@zAzABJAF@@C@RQZM\\WfA_AlAw@t@]f@]h@e@XO`EiDfBiBdBsBh@w@b@i@r@_Az@uAd@{@^_AHM@ICEECCBCLFBRMRWb@cA\\c@h@gAt@oB`@wAF]Ee@BIJOLc@@]P}@@[RaACICEq@WEGAO@QLKDQFp@SAD@BDJ@JJJZ@DCx@IREZEb@@`@IN@\\Kh@g@nBc@pAg@nAILSLg@x@K\\eBnDoA`Bm@bAoAdBcDvD_@`@iAdAiB|AqAx@SPg@Zc@Na@Pc@XWXSL{@v@WJO@OEGEm@m@]a@g@e@u@y@y@w@c@]_@i@COFUCFE@O?OI]c@w@s@a@g@oCaC]a@Wa@g@c@a@WYBMJ_@p@eA~B{@rAEf@Ob@DP?HC?YMUC]OSAMLi@rAILEDU?WODTCDESCBBVAHKCE@CJMUMeA[]WQOi@Y?k@FUJUDSTSJKDM]BSp@eAHA|BgBZ]NI@@FMCCE@@ECEQQSm@WSYk@s@aA]YEIVu@NYb@yAXi@bA{AFEL@HMCi@BIRYb@aAJM?G^i@PQ^o@Ja@d@u@nAgC|AyBl@gAXo@Z_@l@mA`A_BBKPQT]b@}@jAoBTi@dAkBz@cBbBuDV[t@cBpAeCp@yAfAmCXg@h@mAfA_BDCVc@Pc@RWJ_@HKPa@Jc@LYLa@b@_A\\}@jBcEl@wAZgAXkAd@qAdAsDhB}FP_@?SfAgD\\_BJs@Ve@@KNc@JOb@sA^u@ZgA^u@VWDUR[DMBEFAp@At@QfAMDBZKLHDAf@SFCJBb@OL@NEXEFBZEVIFBJEL?RGZGFBRGZEj@QZEHBHAnAYPBNA?SAa@GU@Mo@uA]a@Sm@]g@e@_ASa@EQM[OWAGTYLM^WDKNMBMHCdBaBBFJEPAh@zAR`@Tt@Zd@t@~An@bADRTd@FTXh@~@~@HZN\\PJJb@Zn@J\\RVf@bA`@j@JTH\\@@\\UFFJDHCJGz@o@dAcAJ@JG^_@z@m@n@q@RBBCHEj@m@RCn@s@F?j@i@@?PNR\\l@hBZ`@KMEUnZpaALH@LFJO^BHER]Vw@f@_Ab@K@c@l@WLs@r@MHQ@YFo@TuBd@}@XS@KD@AE?CB?DEFe@JKF_@Je@@{@P_ATm@VK@QEYBgA^GGCQI}@Ae@My@?WMe@EGEA@a@Co@Ia@KY@MIo@?ICCEYGKCQEOGGGCIBEHo@l@m@f@GGEWWk@SIKPIICSBQAOGMMi@AIHGF?Pe@PMJSLKPAG@KCB?CLE@GHAHi@\\IJKBc@ZSHEC_@c@C@LNHPa@l@GAUe@ICBCPJBBDVEJOR{@t@OVMHQR?DRb@FRAJEHoAfAORMFY\\UNqAjAi@`@ODWZ}AhAONe@R]^GTODQTEJiCtBYb@I@YTi@l@WTWP]f@iAbAKDUNKLu@jCM`A_@pAIb@Qf@m@nCGvC@x@C|@APMV@NDT?FQ`C?`@C\\@HCJ?Te@rBc@~Aq@fBCFWRs@pAk@nAUZmCpE{BxCiBpBwBxB_BvA{DlCu@`@wAdAsAjAG?KCGTWd@iA~AwBxDUd@Of@aBpDeFbKwAfCo@zA_CvDOFGAu@[mCeC[QMCY?[BQFWTS\\wA`DaCxEMNYLGFITGp@Q\\gBnBGBG?GEcByDmBwEmAiCm@iB{CeFkCaEWu@YUICa@XOTEBKEi@u@OK_@e@cAeBAGBYQ]{CsEW]E?GFMc@UWOH[b@i@h@_@j@_@`@o@x@aBhByAvAkC`DmApBiC`DKHE@G?UOKOUk@Qs@GIGA]BGCs@}@u@u@w@k@{@k@sBgAcAu@S_@I[OaA]}AIQEA?JDRCF_@y@Gc@EgA[y@I]Q[{BcBWWwAsB_@m@o@o@_@Sc@S{Ae@qCaAw@uAm@o@i@y@w@uAOk@OUCK]QOM_AcB_@e@SMWIEBBTiAJUA_@BU?WEOKc@?UGw@c@MCo@ZQDSAi@K_@@aBs@k@_@e@UW_@AaBGOsAUGCKIC@';
  const pData2 = [
    [37.60519,126.89454],
    [37.60504,126.89462],
    [37.60500,126.89483],
    [37.60503,126.89485],
    [37.60499,126.89489],
    [37.60498,126.89496],
    [37.60502,126.89503],
    [37.60501,126.89508],
    [37.60502,126.89515],
    [37.60105,126.93288],
    [37.60102,126.93292],
    [37.60106,126.93320],
    [37.60106,126.93332],
    [37.60105,126.93336],
    [37.60094,126.93347],
    [37.60090,126.93359],
    [37.60087,126.93382],
    [37.60084,126.93397],
    [37.60086,126.93412],
    [37.60083,126.93419],
    [37.60083,126.93434],
    [37.60078,126.93474],
    [37.60078,126.93494],
    [37.60076,126.93506],
    [37.60068,126.93520],
    [37.60062,126.93525],
    [37.60062,126.93541],
    [37.60058,126.93557],
    [37.60052,126.93568],
    [37.60027,126.93591],
    [37.60007,126.93604],
    [37.60001,126.93611],
    [37.59989,126.93619],
    [37.59981,126.93621],
    [37.59972,126.93630],
    [37.59947,126.93646],
    [37.59927,126.93669],
    [37.59912,126.93676],
    [37.59902,126.93684],
    [37.59899,126.93693],
    [37.59882,126.93716],
    [37.59869,126.93730],
    [37.59860,126.93748],
    [37.60476,126.89460],
    [37.60481,126.89460],
    [37.60484,126.89461],
  ];

  let polylineData = [];

  let i = 0;
  _.forEach(decodePolyline(pData), function(l) {
    polylineData.push([(Number(l.lng)), Number(l.lat)]);
  });

  const geoJson = {
    type: 'FeatureCollection',
    features: [
      {
        type: 'Feature', 
        geometry: {
          type: 'LineString', 
          coordinates: [...polylineData],
        }
      }
    ]
  };

  const geoJson2 = {
    type: 'FeatureCollection',
    features: [
      {
        type: 'Feature', 
        geometry: {
          type: 'LineString', 
          coordinates: [...pData2],
        }
      }
    ]
  };



  const layerStyle = {
    id: 'Austrailia',
    type : 'line',
    paint : {
      'line-color': "#f187f1",
      'line-width': 5,
      'line-opacity': 0.7,
  //      'line-gradient': []
    },
    'line-cap': 'round',
    'visibility':'visible',
  };

  const layerStyle2 = {
    id: 'Afreeca',
    type : 'line',
    paint : {
      'line-color': "#007cbf",
      'line-width': 5,
      'line-opacity': 0.7,
  //      'line-gradient': []
    },
    'line-cap': 'round',
    'visibility':'visible',
  };  

//
//

  return (
    <div className={classes.root}>
      <Typography variant="h3" className={classes.title}>
        준비중입니다
      </Typography>
      <MapGL
        {...viewport}
//        transitionDuration={500}      
//        transitionInterpolator={new FlyToInterpolator()} 
        onViewportChange={(viewport) => {        
          setViewport(viewport);      
        }}
        mapStyle="mapbox://styles/mapbox/light-v9" 
        mapboxApiAccessToken={MAPBOX_TOKEN}
      >
        <Source id="my-data" type="geojson" data={geoJson}>
          <Layer {...layerStyle} />
        </Source>

        <Source id="my-data2" type="geojson" data={geoJson2}>
          <Layer {...layerStyle2} />
        </Source>

        <div className="navi-control">        
          <NavigationControl style={{position:'absolute', top:'6px', left:'6px'}} />      
        </div>
        <div className="current-location-control">        
          <GeolocateControl style={{position:'absolute', top:'6px', right:'6px'}} />
        </div>
        <div className="marker-list">        
          <Marker latitude={37.591647} longitude={126.943329} style={{width:'36px', height:'50px', padding:'0px'}} offsetLeft={-18} offsetTop={-39}>
            <RoomIcon style={{width:'36px', height:'50px', color:'#ff9900'}}/>
          </Marker>
        </div>
      </MapGL>
		</div>
  );
}


export default Map;
